import React, { useEffect, useState } from 'react';
import { Grid, Paper, LinearProgress, Tooltip } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { useTheme } from '@mui/material/styles';
import SideBar from './sideBar';
import LineChartToggle from './lineChartToggle';
import Rightbar from './rightbar';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import UpdateIcon from '@mui/icons-material/Update';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import NoDataImg from '../../../assets/images/No_data-amico.svg';
// import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import GroupIcon from '@mui/icons-material/Group';
import dummydata from './data.json';
import { getCustomerDwellTime, getCustomerEmployeeRatio, getEmployeeAvailability, getUniqueWalkinWalkout } from 'api';
import { SkeletonLoader } from '../../../component/SkeletonLoader';

const StorePage = () => {
  const theme = useTheme();
  // const navigateTo = useNavigate();
  const date = useSelector((state) => state.customization.currentDate);
  const [avgWaitingData, setAvgWaitingData] = useState(false);
  const [avgWaiting, setAvgWaiting] = useState(false);
  const [storeName, setStoreName] = useState('');

  const [storeDwelTime, setStoreDwelTime] = useState(false);
  const [dweltimeData, setDweltimedata] = useState(false);
  const [footfalldata, setFootfalldata] = useState(false);
  const [ftfall, setftfall] = useState([]);
  const [empFtFallCount, setEmpFtFallCount] = useState(false);
  const [empZoneCounts, setEmpZoneCounts] = useState(false);
  const [cusAssRatio, setCusAssRatio] = useState(false);
  const [cusAssRatioData, setCusAssRatioData] = useState(false);
  const selectedTime = useSelector((state) => state.customization.selectedTime);
  const startTime = selectedTime?.start_time ? new Date(selectedTime.start_time) : new Date();
  const endTime = selectedTime?.end_time ? new Date(selectedTime.end_time) : new Date();
  const start_time = startTime.toUTCString();
  const end_time = endTime.toUTCString();
  const [isMounted, setIsMounted] = useState(false);

  // Loading states for each API call
  const [isFootfallLoading, setIsFootfallLoading] = useState(true);
  const [isDwellTimeLoading, setIsDwellTimeLoading] = useState(true);
  const [isEmpAvailabilityLoading, setIsEmpAvailabilityLoading] = useState(true);
  const [isCusAssRatioLoading, setIsCusAssRatioLoading] = useState(true);
  const [departments, setDepartments] = useState([]);

  // const source = JSON.parse(localStorage.getItem('source'));
  const source = "trends";

  // Get store name from localStorage if available
  useEffect(() => {
    // const storedName = localStorage.getItem('storeName');
    const storedName = "RCP - Trends";
    if (storedName) {
      setStoreName(storedName);
    } else {
      setStoreName('Store Insight'); // Default fallback
    }
  }, []);

  async function getDepartments(signal) {
    try {
      const response = await fetch('https://disha-pocket.neophyte.live/trends-api/api/sentinel/getDepartments', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          source_id: source
        }),
        signal: signal
      });
      const data = await response.json();
      if (!signal.aborted && data.status === 200) {
        setDepartments(data.data);
      }
    } catch (error) {
      if (!signal.aborted) {
        console.error('Error fetching departments:', error);
      }
    }
  }

  async function getDataDwell(commonBody, signal) {
    setIsDwellTimeLoading(true);
    try {
      const requestData = {
        date: commonBody,
        source_id: source,
        start_time: start_time,
        end_time: end_time
      };
      const response = await getCustomerDwellTime(requestData);
      const data = response.data.data[0].avgDwelTime;

      if (!signal.aborted) {
        if (!data || data.zone_wise_dwell_time.length === 0) {
          setStoreDwelTime(false);
          setDweltimedata(false);
        } else {
          setStoreDwelTime(data.dwel_time);
          setDweltimedata(data.zone_wise_dwell_time);
        }
        setIsDwellTimeLoading(false);
      }
    } catch (error) {
      if (!signal.aborted) {
        setStoreDwelTime(false);
        setDweltimedata(false);
        setIsDwellTimeLoading(false);
        console.log(error);
      }
    }
  }

  async function getFootfalldata(commonBody, signal) {
    setIsFootfallLoading(true);
    try {
      const requestData = {
        date: commonBody,
        source_id: source,
        start_time: start_time,
        end_time: end_time
      };
      const response = await getUniqueWalkinWalkout(requestData);
      const data = response.data.data[0]?.footfall;

      if (!signal.aborted) {
        if (!data || data.zoneFootfall.length === 0) {
          setFootfalldata(false);
          setftfall(false);
        } else if (data && data.zoneFootfall.length > 0) {
          const avgFootfall = data.store_footfall;
          const zoneFootfall = data.zoneFootfall;
          const employeeftfall = data.employee_footfall;
          setEmpFtFallCount(employeeftfall);
          setftfall(zoneFootfall);
          setFootfalldata(avgFootfall);
        }
        setIsFootfallLoading(false);
      }
    } catch (error) {
      if (!signal.aborted) {
        setFootfalldata(false);
        setftfall(false);
        setIsFootfallLoading(false);
        console.log(error);
      }
    }
  }

  async function getAvgWaitingTime(commonBody, signal) {
    setIsEmpAvailabilityLoading(true);
    try {
      const requestData = {
        date: commonBody,
        source_id: source,
        start_time: start_time,
        end_time: end_time
      };
      const response = await getEmployeeAvailability(requestData);
      const data = response.data.data; // Extract the relevant data

      if (!signal.aborted) {
        if (!data || !data.allZones || data.allZones.length === 0) {
          setAvgWaiting(0);
          setAvgWaitingData([]);
        } else {
          const avgTime = data.avgAvail || 0;

          const zoneData = data.allZones.map((zone) => ({
            _id: zone.zone, // Using `zone` as the zone name (_id)
            empPercentage: zone.percentAvail, // Mapping percentAvail to count
            empCount: zone.count
          }));

          // Update state
          setAvgWaiting(avgTime);
          setAvgWaitingData(zoneData);
        }
        setIsEmpAvailabilityLoading(false);
      }
    } catch (error) {
      if (!signal.aborted) {
        setAvgWaiting(0);
        setAvgWaitingData([]);
        setIsEmpAvailabilityLoading(false);
        console.log('Error fetching employee availability:', error);
      }
    }
  }

  async function getEmpFootfallCount(commonBody, signal) {
    try {
      const data = dummydata.employeeEntranceCount;

      if (!signal.aborted) {
        if (!data || data.length === 0) {
          setEmpFtFallCount(false);
        } else if (data && data.length > 0) {
          // Handle dummy data if needed
        }
      }
    } catch (error) {
      if (!signal.aborted) {
        setEmpFtFallCount(false);
        console.log(error);
      }
    }
  }

  async function getEmpZonewiseCount(commonBody, signal) {
    try {
      const data = dummydata.zoneEmployeeCount;

      if (!signal.aborted) {
        if (!data || data.length === 0) {
          setEmpZoneCounts(false);
        } else if (data && data.length > 0) {
          setEmpZoneCounts(data);
        }
      }
    } catch (error) {
      if (!signal.aborted) {
        setEmpZoneCounts(false);
        console.log(error);
      }
    }
  }

  async function getCustomerAssociateRatio(commonBody, signal) {
    setIsCusAssRatioLoading(true);
    try {
      const requestData = {
        date: commonBody,
        source_id: source,
        start_time: start_time,
        end_time: end_time
      };
      const response = await getCustomerEmployeeRatio(requestData);

      if (!signal.aborted) {
        const data = response?.data?.data || [];
        console.log(data);

        if (data.length === 0) {
          setCusAssRatio(false);
          setCusAssRatioData(false);
        } else {
          setCusAssRatioData(data);

          const ratios = data.map((obj) => parseFloat(obj.employee_to_customer_ratio.split(':')[1]) || 0);
          const avgRatio = ratios.length > 0 ? (ratios.reduce((acc, val) => acc + val, 0) / ratios.length).toFixed(2) : 'N/A';
          setCusAssRatio(avgRatio);
        }
        setIsCusAssRatioLoading(false);
      }
    } catch (error) {
      if (!signal.aborted) {
        setCusAssRatio(false);
        setCusAssRatioData(false);
        setIsCusAssRatioLoading(false);
        console.error('Error fetching customer-employee ratio:', error);
      }
    }
  }

  useEffect(() => {
    setIsMounted(true);
    return () => {
      setIsMounted(false);
    };
  }, []);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    if (isMounted) {
      const commonBody = {
        start_date: date
      };

      const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toISOString().split('T')[0];
      };

      const formattedDate = formatDate(date);

      getFootfalldata(formattedDate, signal);
      getDataDwell(formattedDate, signal);
      getEmpFootfallCount(commonBody, signal);
      getEmpZonewiseCount(commonBody, signal);
      getAvgWaitingTime(formattedDate, signal);
      getCustomerAssociateRatio(formattedDate, signal);
      getDepartments(signal);
    }

    return () => {
      abortController.abort();
    };
  }, [date, isMounted, selectedTime]);

  // We don't reset selectedTime on mount anymore to preserve the date selected in the calendar
  // This ensures the selected date from the calendar is maintained when navigating between pages

  const mainContentStyle = {
    maxWidth: '100%',
    minWidth: '0',
    height: '100%',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      width: '100%'
    }
  };

  const paperStyle = {
    width: '100%',
    maxHeight: '280px',
    height: '280px',
    padding: '10px',
    marginBottom: '20px',
    position: 'relative',
    left: 'auto',
    borderRadius: '15px',
    display: 'flex',
    alignItems: 'center',
    flex: '1'
  };

  ftfall && ftfall.sort((a, b) => a.footfall - b.footfall);
  dweltimeData && dweltimeData.sort((a, b) => a.averageDuration - b.averageDuration);
  empZoneCounts && empZoneCounts.sort((a, b) => a.count - b.count);
  avgWaitingData && avgWaitingData.sort((a, b) => b.avg - a.avg);

  return (
    <Grid container spacing={1}>
      <SideBar selField="storeOverview" />
      <Grid item md={12} sx={mainContentStyle}>
        {/* Store Name Header */}
        <div className="flex items-center mb-5 -mt-10 pl-2">
          <h1 className="text-2xl font-bold text-gray-800">{storeName}</h1>
        </div>
        <Grid container spacing={1}>
          {/* Footfall Trend Card */}
          <Grid
            item
            xs={12}
            md={3}
            sm={6}
            sx={{
              width: '100%',
              mb: -1,
              mt: 1,
              [theme.breakpoints.up('sm')]: {
                mb: -1,
                mt: 1
              },
              [theme.breakpoints.up('md')]: {
                mb: -1,
                mt: -1
              }
            }}
          >
            <Paper elevation={3} sx={paperStyle}>
              {isFootfallLoading ? (
                <SkeletonLoader />
              ) : ftfall && ftfall.length > 0 ? (
                <div className="flex w-full flex-col gap-1">
                  <div className="flex items-center justify-center gap-2 w-full">
                    <DirectionsWalkIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                    <div className="w-full">
                      <div className="flex items-center gap-2">
                        <div className="flex items-center gap-1">
                          <p className="text-3xl">{footfalldata ? Math.round(footfalldata) : 0}</p>
                          <p className="text-sm text-gray-600 mt-1">Cust.</p>
                        </div>
                        <div className="h-8 w-[1px] bg-gray-300"></div>
                        <div className="flex items-center gap-1">
                          <p className="text-3xl">{empFtFallCount || 0}</p>
                          <p className="text-sm text-gray-600 mt-1">Emp.</p>
                        </div>
                      </div>
                      <p className="text-lg mt-1">Footfall Trend</p>
                    </div>
                  </div>
                  <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                    {(() => {
                      const maxFootfall = Math.max(...ftfall.map((item) => item.footfall));
                      return ftfall.map((item, index) => {
                        const percentage = (item.footfall / maxFootfall) * 100;
                        const barcolor = percentage >= 80 ? '#44BE54' : percentage >= 50 ? '#ffbf00' : '#ff413a';

                        const department = departments.find((dept) => dept.name === item.zone_name);
                        const zoneColor = department ? department.color : '#2D9BBC';

                        return (
                          <div className="mt-2" key={index}>
                            <div className="flex gap-1 items-center">
                              <div className="rounded-full h-4 w-4" style={{ backgroundColor: zoneColor }}></div>
                              <div>
                                {item.zone_name} : {item.footfall}
                              </div>
                            </div>
                            <LinearProgress
                              variant="determinate"
                              value={percentage}
                              sx={{
                                marginTop: '5px',
                                backgroundColor: '#c8c8c8',
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: `${barcolor}`
                                }
                              }}
                            />
                          </div>
                        );
                      });
                    })()}
                  </div>
                </div>
              ) : (
                <img className="w-80 h-80 ml-10 mb-10" src={NoDataImg} alt="No data" />
              )}
            </Paper>
          </Grid>

          {/* Avg Dwell Time Card */}
          <Grid
            item
            xs={12}
            md={3}
            sm={6}
            sx={{
              width: '100%',
              mb: -1,
              mt: 1,
              [theme.breakpoints.up('sm')]: {
                mb: -1,
                mt: 1
              },
              [theme.breakpoints.up('md')]: {
                mb: -1,
                mt: -1
              }
            }}
          >
            <Paper elevation={3} sx={paperStyle}>
              {isDwellTimeLoading ? (
                <SkeletonLoader />
              ) : dweltimeData && dweltimeData.length > 0 ? (
                <div className="flex flex-col w-full gap-1">
                  <div className="flex items-center justify-center gap-2 w-full">
                    <UpdateIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                    <div className="w-full">
                      <p className="text-3xl">
                        {storeDwelTime >= 3600
                          ? `${Math.round(storeDwelTime / 3600)} hr`
                          : storeDwelTime >= 60
                            ? `${Math.round(storeDwelTime / 60)} min`
                            : `${Math.round(storeDwelTime)} sec`}
                      </p>
                      <p className="text-lg">Avg Dwell Time</p>
                    </div>
                  </div>
                  <div className=" bg-slate-100 flex-grow overflow-y-auto h-[184px] scrollbar rounded-lg p-2.5">
                    {dweltimeData.map((item, index) => {
                      const percentage = (item.averageDuration / storeDwelTime) * 100;
                      const barcolor = percentage >= 80 ? '#44BE54' : percentage >= 50 ? '#ffbf00' : '#ff413a';

                      const department = departments.find((dept) => dept.name === item.zone_name);
                      const zoneColor = department ? department.color : '#2D9BBC';
                      return (
                        <div className="mt-2" key={index}>
                          <div className="flex gap-1 items-center">
                            <div
                              className=" rounded-full h-4 w-4"
                              style={{
                                backgroundColor: zoneColor
                              }}
                            >
                              {' '}
                            </div>
                            <div>
                              {item.zone_name} :{' '}
                              {item.averageDuration >= 3600
                                ? `${Math.round(item.averageDuration / 3600)} hr`
                                : item.averageDuration >= 60
                                  ? `${Math.round(item.averageDuration / 60)} min`
                                  : `${Math.round(item.averageDuration)} sec`}
                            </div>
                          </div>
                          <LinearProgress
                            variant="determinate"
                            value={Math.min(100, percentage)}
                            sx={{
                              marginTop: '5px',
                              backgroundColor: '#c8c8c8',
                              '& .MuiLinearProgress-bar': {
                                backgroundColor: `${barcolor}`
                              }
                            }}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                <img className="w-80 h-80 ml-10 mb-10" src={NoDataImg} alt="No data" />
              )}
            </Paper>
          </Grid>

          {/* Avg Emp. Availability Card */}

          <Grid
            item
            md={3}
            sm={6}
            sx={{
              width: '100%',
              mb: -1,
              mt: 1,
              [theme.breakpoints.up('sm')]: {
                mb: -1,
                mt: 1
              },
              [theme.breakpoints.up('md')]: {
                mb: -1,
                mt: -1
              }
            }}
          >
            <Paper elevation={3} sx={paperStyle}>
              {isEmpAvailabilityLoading ? (
                <SkeletonLoader />
              ) : avgWaitingData && avgWaitingData.length > 0 ? (
                <div className="flex w-full flex-col gap-1">
                  <div className="flex items-center justify-center gap-2 w-full">
                    <EmojiPeopleIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                    <div className="w-full">
                      <div className="flex items-baseline gap-2">
                        <p className="text-3xl">{avgWaiting.toFixed(2)}%</p>
                        {start_time && end_time && (
                          <span className="text-sm text-gray-500 align-super">
                            {(() => {
                              const start = new Date(start_time);
                              const end = new Date(end_time);
                              const diffMs = end - start;

                              const hours = Math.floor(diffMs / (1000 * 60 * 60));
                              const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

                              if (hours > 0 && minutes > 0) {
                                return `${hours}${hours === 1 ? 'hr' : 'hrs'} ${minutes}${minutes === 1 ? 'min' : 'mins'}`;
                              } else if (hours > 0) {
                                return `${hours}${hours === 1 ? 'hr' : 'hrs'}`;
                              } else if (minutes > 0) {
                                return `${minutes}${minutes === 1 ? 'min' : 'mins'}`;
                              }
                              return '0min';
                            })()}
                          </span>
                        )}
                      </div>
                      <p>
                        <span className="text-lg">Avg Emp. Availability</span>
                      </p>
                    </div>
                  </div>
                  <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                    {(() => {
                      const sortedData = [...avgWaitingData].sort((a, b) => a.empPercentage - b.empPercentage);
                      const highestFootfall = Math.max(...sortedData.map((zone) => zone.empPercentage), 1);

                      return sortedData.map((item, index) => {
                        const percentage = ((item.empPercentage / highestFootfall) * 100).toFixed(1);
                        const barcolor = percentage >= 80 ? '#44BE54' : percentage >= 50 ? '#ffbf00' : '#ff413a';
                        const department = departments.find((dept) => dept.name === item._id);
                        const zoneColor = department ? department.color : '#2D9BBC';
                        return (
                          <div className="mt-2" key={index}>
                            <div className="flex gap-1 items-center">
                              <div
                                className="rounded-full h-4 w-4"
                                style={{
                                  backgroundColor: zoneColor
                                }}
                              >
                                {' '}
                              </div>
                              <div className="flex gap-2 items-center">
                                {item._id} : {item.empPercentage}%
                                <Tooltip title={`Employee Count: ${item.empCount}`} arrow placement="right">
                                  <InfoIcon sx={{ fontSize: 16, color: '#666', cursor: 'pointer' }} />
                                </Tooltip>
                              </div>
                            </div>
                            <LinearProgress
                              variant="determinate"
                              value={parseFloat(percentage)}
                              sx={{
                                marginTop: '5px',
                                backgroundColor: '#c8c8c8',
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: `${barcolor}`
                                }
                              }}
                            />
                          </div>
                        );
                      });
                    })()}
                  </div>
                </div>
              ) : (
                <img className="w-80 h-80 ml-10 mb-10" src={NoDataImg} alt="No data" />
              )}
            </Paper>
          </Grid>

          {/* Employee : Customer Card */}
          <Grid
            item
            md={3}
            sm={6}
            sx={{
              width: '100%',
              mb: -1,
              mt: 1,
              [theme.breakpoints.up('sm')]: {
                mb: -1,
                mt: 1
              },
              [theme.breakpoints.up('md')]: {
                mb: -1,
                mt: -1
              }
            }}
          >
            <Paper elevation={3} sx={paperStyle}>
              {isCusAssRatioLoading ? (
                <SkeletonLoader />
              ) : cusAssRatioData && cusAssRatioData.length > 0 ? (
                <div className="flex w-full flex-col gap-1">
                  <div className="flex items-center justify-center gap-2 w-full">
                    <GroupIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                    <div className="w-full">
                      <p className="text-3xl">1 : {cusAssRatio}</p>
                      <p>
                        <span className="text-[1.090rem]">Employee : Customer</span>
                      </p>
                    </div>
                  </div>
                  <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                    {(() => {
                      const sortedData = [...cusAssRatioData].sort((a, b) => {
                        const ratioA = parseFloat(a.employee_to_customer_ratio.split(':')[1]) || 0;
                        const ratioB = parseFloat(b.employee_to_customer_ratio.split(':')[1]) || 0;
                        return ratioB - ratioA;
                      });

                      const highestFootfall = Math.max(
                        ...sortedData.map((obj) => parseFloat(obj.employee_to_customer_ratio.split(':')[1]) || 0),
                        1
                      );

                      return sortedData.map((item, index) => {
                        const ratioValue = parseFloat(item.employee_to_customer_ratio.split(':')[1]) || 0;
                        const percentage = ((ratioValue / highestFootfall) * 100).toFixed(1);
                        const barcolor = percentage >= 80 ? '#ff413a' : percentage >= 50 ? '#ffbf00' : '#44BE54';
                        const department = departments.find((dept) => dept.name === item.zone);
                        const zoneColor = department ? department.color : '#2D9BBC';

                        return (
                          <div className="mt-2" key={index}>
                            <div className="flex gap-1 items-center">
                              <div className="rounded-full h-4 w-4" style={{ backgroundColor: zoneColor }}></div>
                              <div>
                                {item.zone} - {item.employee_to_customer_ratio}
                              </div>
                            </div>
                            <LinearProgress
                              variant="determinate"
                              value={parseFloat(percentage)}
                              sx={{
                                marginTop: '5px',
                                backgroundColor: '#c8c8c8',
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: `${barcolor}`
                                }
                              }}
                            />
                          </div>
                        );
                      });
                    })()}
                  </div>
                </div>
              ) : (
                <img className="w-80 h-80 ml-10 mb-10" src={NoDataImg} alt="No data" />
              )}
            </Paper>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item md={9} sm={12}>
            <LineChartToggle />
          </Grid>
          <Grid item md={3} sm={12}>
            <Rightbar />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default StorePage;
